import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IInventoryResponseBody } from 'src/api/getInventory';

export const getInventory = async (
  limit: number = 50,
  nextItemId?: string,
  name?: string,
  productType?: ('RECIPE' | 'GOOD')[],
): Promise<IInventoryResponseBody> => {
  try {
    const url = new URL(`${API_URL}/recipes?limit=${limit}`);
    if (nextItemId) {
      url.searchParams.append('after_id', nextItemId);
    }
    if (name) {
      url.searchParams.append('name', name);
    }
    if (productType && productType.length > 0) {
      productType.forEach((type) => url.searchParams.append('product_type', type));
    }
    const res = await fetch(url.href);

    if (!res.ok) throw new Error(res.statusText);

    return await res.json();
  } catch (e) {
    throw new Error('Could not fetch inventory', { cause: e });
  }
};
